import React from "react";
import "./OrderTable.css";
import {BsCheck2All} from 'react-icons/bs'

const OrderTable = (props) => {
  const { item, product,markAsRead,markAsUnRead } = props;

  return (
    <>
      <div className="containe">
        <div className="orders">
          <ul key={item.id}>
            <li>
              <span className="orders-title">Payment ID :</span>{" "}
              {item.paymentId}
            </li>
            <li>
              <span className="orders-title">Order ID :</span> {item.orderId}
            </li>
            <li>
              <span className="orders-title">Name :</span> {item.name}
            </li>
            <li>
              <span className="orders-title">Phone No :</span> {item.phoneNo}
            </li>
            <li>
              <span className="orders-title">Address :</span> {item.address}
            </li>
            <li>
              <span className="orders-title">City :</span> {item.city}
            </li>
            <li>
              <span className="orders-title">State :</span> {item.state}
            </li>
            <li>
              <span className="orders-title">Products:</span>
              {product.map((e) => {
                return (
                  <p>
                  <span className="orders-title"> Title :</span>  {e.title} <br />
                  <span className="orders-title">  Quantity :</span>  {e.Qty} <br />
                  <span className="orders-title">Size :</span>  {e.size} <br />
                  <span className="orders-title">  Color :</span>  {e.color}
                  </p>
                );
              })}
            </li>
            <li>
              <span className="orders-title">Time :</span> {item.orderedAt.toDate().toLocaleTimeString('en-US')}
            </li>
            <li>
              <span className="orders-title">Date :</span> {item.orderedAt.toDate().toDateString()}
            </li>

            <li>
            <span className="orders-title">Read :</span> {!item.markAsRead ? 'UnRead' : <BsCheck2All style={{color:'green',fontSize:'30px'}}/>}

            </li>
            <li>
              {
                !item.markAsRead ?
                <button type="button" class="btn btn-outline-success" onClick={()=>markAsRead(item.id)}>Mark as Read</button>
                :
                <button type="button" class="btn btn-outline-danger" onClick={()=>markAsUnRead(item.id)}>Mark as UnRead</button>

              }

            </li>
           
          </ul>
        </div>
      </div>
      {/* <hr /> */}
    </>
  );
};

export default OrderTable;
